import type { AgrupamentoCarga } from "@/modules/recursos";
import type { EmptyStateContent } from "../types-carga-de-trabalho";

import type { CargaEstadoIds } from "../components/carga-estado";
import type { CargaToolbarIds } from "../components/carga-toolbar";

/** Tooltip do "Agrupar por", no mesmo texto da perspectiva de Profissionais. */
export const GROUPING_HINT =
  "Muda como as linhas são agrupadas: por obra ou pelo recurso. Os dados são os mesmos.";

/** Legenda do Gantt de Fornecedor: Obra e Cancelada; o "Hoje" é da própria legenda. */
export const LEGEND: { key: string; label: string }[] = [
  { key: "obra", label: "Obra" },
  { key: "cancelada", label: "Cancelada" },
];

export const VAZIO: Record<AgrupamentoCarga, EmptyStateContent> = {
  fornecedor: {
    title: "Nenhuma alocação de fornecedor no período",
    description: "Ajuste o período selecionado para visualizar a carga de trabalho.",
  },
  obra: {
    title: "Nenhuma obra com fornecedores alocados no período",
    description: "Ajuste o período selecionado para visualizar a carga de trabalho.",
  },
};

export const VAZIO_BUSCA: Record<AgrupamentoCarga, EmptyStateContent> = {
  fornecedor: {
    title: "Nenhum fornecedor corresponde à busca.",
    description: "Tente revisar o termo pesquisado",
  },
  obra: {
    title: "Nenhuma obra corresponde à busca.",
    description: "Tente revisar o termo pesquisado",
  },
};

export const TOOLBAR_IDS: CargaToolbarIds = {
  toolbar: "carga-toolbar",
  search: "carga-search",
  periodo: "carga-periodo",
  agrupamento: "carga-agrupamento",
  agrupamentoHint: "carga-agrupamento-hint",
  filtros: "carga-filtros",
  perspectivas: "carga-perspectiva",
  menu: "carga-menu",
  menuExportar: "carga-menu-exportar",
  menuIndicadores: "carga-menu-indicadores",
};

export const ESTADO_IDS: CargaEstadoIds = {
  forbidden: "carga-forbidden",
  loading: "carga-loading",
  error: "carga-error",
  retry: "carga-retry",
  empty: "carga-empty",
};

export const CHIP_TEST_ID_PREFIX = "carga-chip";
export const LEGEND_TEST_ID = "carga-legenda";
